<div class="logo-container">
  <app-shared-logo [isFullSize]="!isCollapsed && !isCollapsedDelayed"/>
</div>
<!--TODO: check locale settings or create pipe -> @David maybe you can use date-fns-adapter for it-->
<mat-list class="home-buttons">
  <mat-list-item class="sidebar-list-item sidebar-header-list-item"
                 [matTooltip]="isCollapsed ? currentDateString + ' ' + currentTimeString : null"
                 matTooltipShowDelay="200"
                 matTooltipPosition="right">
    <app-core-sidebar-list-item class="mat-body-small" [collapsed]="isCollapsed || isCollapsedDelayed" icon="calendar">
      @if (!isCollapsed) {
        {{ currentDateString }}
        <span class="time">{{ currentTimeString }}</span>
      }
    </app-core-sidebar-list-item>
  </mat-list-item>

  @let homeLabel = 'Projekte' | translate : 'sidebar-action-projects' : 'feature/secure' ;

  <mat-list-item class="sidebar-list-item sidebar-header-list-item mat-mdc-list-item-interactive"
                 [routerLink]="CORE_ROUTES.PROJECTS"
                 [class.selected]="isHomeRouted()"
                 [matTooltip]="isCollapsed ? homeLabel : null"
                 matTooltipShowDelay="200"
                 matTooltipPosition="right"
                 tabindex="0"
                 role="button">
    <app-core-sidebar-list-item [collapsed]="isCollapsed || isCollapsedDelayed" [name]="homeLabel" icon="house"/>
  </mat-list-item>
</mat-list>
